/*
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
*/

import gql from 'graphql-tag';

export const PEOPLE_QUERY = gql`
  query People {
    search(type: Person) {
      edges {
        node {
          id
          ... on Person {
            dbId
            name {
              value
            }
            email {
              value
            }
            userRole {
              value
            }
          }
        }
      }
    }
  }
`;

export const WORKFLOW_GROUPS_QUERY = gql`
  query WorkflowGroups {
    search(type: WorkflowGroup) {
      edges {
        node {
          ... on WorkflowGroup {
            id
            title {
              value
            }
            updatedAt {
              value
            }
          }
        }
      }
    }
  }
`;

export const WORKFLOW_STEPS_QUERY = gql`
  query ObjectTemplate {
    search(type: ObjectTemplate) {
      edges {
        node {
          id
          ... on ObjectTemplate {
            dbId
            active {
              value
            }
            title {
              value
            }
            actionTrigger {
              value
            }
            riskThreshold {
              value {
                id
                title {
                  value
                }
              }
            }
            sourceType {
              value
            }
            triggerType {
              value
            }
            content {
              value
            }
            objectType {
              value
            }
            workflowGroup {
              value {
                id
              }
            }
            order {
              value
            }
          }
        }
      }
    }
  }
`;

export const WORKFLOW_TRANSITIONS_QUERY = gql`
  query WorkflowTransitions {
    workflow {
      value {
        objectType
        transitions {
          name
          status
          targetStatus
        }
      }
    }
    riskThresholds: search(
      type: RiskVectorScore
      filter: "{\\"left\\":\\"formula_type\\", \\"op\\":{\\"name\\": \\"=\\"}, \\"right\\": \\"Score\\"}"
    ) {
      edges {
        node {
          ... on RiskVectorScore {
            id
            title {
              value
            }
            thresholds {
              value {
                edges {
                  node {
                    id
                    title {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const WORKFLOW_GROUP_CREATE = gql`
  mutation createWorkflowGroup($input: CreateWorkflowGroupInput!) {
    result: createWorkflowGroup(input: $input, dryRun: false) {
      group: result {
        id
        title {
          value
        }
        updatedAt {
          value
        }
      }
    }
  }
`;

export const WORKFLOW_STEP_CREATE = gql`
  mutation createObjectTemplate($input: CreateObjectTemplateInput!) {
    result: createObjectTemplate(input: $input, dryRun: false) {
      step: result {
        id
        active {
          value
        }
        title {
          value
        }
        actionTrigger {
          value
        }
        sourceType {
          value
        }
        content {
          value
        }
        objectType {
          value
        }
        workflowGroup {
          value {
            id
          }
        }
        order {
          value
        }
      }
    }
  }
`;

export const WORKFLOW_GROUP_UPDATE = gql`
  mutation updateWorkflowGroup($id: ID!, $input: UpdateWorkflowGroupInput!) {
    result: updateWorkflowGroup(id: $id, input: $input) {
      group: result {
        id
        title {
          value
        }
        updatedAt {
          value
        }
      }
    }
  }
`;

export const WORKFLOW_STEPS_UPDATE = gql`
  mutation UpdateTask($id: ID!, $input: UpdateObjectTemplateInput!) {
    result: updateObjectTemplate(id: $id, input: $input) {
      template: result {
        id
        active {
          value
        }
        content {
          value
        }
        order {
          value
        }
      }
    }
  }
`;

export const OBJECT_DELETE_BY_ID = gql`
  mutation deleteObjectsById($ids: [ID!]) {
    result: deleteObjectsById(ids: $ids) {
      removedIds
    }
  }
`;
